"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WINDOW_ALIVE = exports.DIRECTOR_WINDOW = void 0;
var DIRECTOR_WINDOW = exports.DIRECTOR_WINDOW = 'director_window';
var WINDOW_ALIVE = exports.WINDOW_ALIVE = 'alive';